// src/components/Reusable/DashboardLayout.js
import React from 'react';
import { Box, useMediaQuery } from '@mui/material';
import Navigation from '../Reusbale/Navigation'; // Adjust import path if necessary
import Footer from '../Reusbale/Footer';       // Adjust import path if necessary

/**
 * Reusable Dashboard Layout component.
 * Provides a consistent structure with a sidebar navigation and a footer,
 * wrapping the main content area.
 *
 * @param {object} props - The component props.
 * @param {React.ReactNode} props.children - The content to be rendered within the main dashboard area.
 */
const DashboardLayout = ({ children }) => {
  const isMobile = useMediaQuery('(max-width: 960px)'); // Use the same breakpoint as Navigation

  return (
    <Box sx={{ minHeight: '100vh', width: '100%' }}>
      {/* Navigation Drawer */}
      <Navigation />

      {/* Main Content Area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          // Adjust padding and margin based on navigation width and mobile state
          pl: { xs: 2, sm: 4, md: 4 }, // More left padding on larger screens to account for drawer
          pr: { xs: 2, sm: 4, md: 4 },
          backgroundColor: '#EEF2F7',
          minHeight: '100vh',
          marginLeft: { xs: 0, md: '270px' },
          paddingTop: isMobile ? '74px' : '32px',
        }}
      >
        {children} {/* This is where your specific dashboard content will render */}


      <Footer />

      </Box>

   
    </Box>
  );
};

export default DashboardLayout;